import { useState, useEffect } from "react"
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  FormGroup,
  Col,
  Form,
  Button,
  Label,
  InputGroup
} from "reactstrap"
import InputPasswordToggle from "../CustomComponent/input-toggle"

import { toast } from "react-toastify"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import { postUpdatePasswordV2 } from "../../services/endpointUtils/authV2"
import AuthLogout from "../../services/endpointUtils/logout"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { setIsAcess } from "../../redux/actions"

const MySwal = withReactContent(Swal)

const UpdatePassword = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  //  password state
  const [formValues, setFormValues] = useState({
    old_pass: "",
    password: "",
    password2: ""
  })

  // Api to Post to update user password

  const updatePassword = async () => {
    // The account is the one the token belongs to, so the body is just the
    // two passwords — no app, no user name.
    postUpdatePasswordV2({
      old_password: formValues.old_pass,
      new_password: formValues.password
    })
      .then((response) => {
        const responseCode = response?.data?.response_code ?? response?.data?.responseCode

        if (responseCode === 200 || responseCode === 202) {
          const successMessage =
            response?.data?.data?.message ||
            response?.data?.data?.result?.success ||
            "Password updated successfully"

          MySwal.fire({
            icon: "success",
            title: "Please notice !",
            text: successMessage,
            customClass: {
              confirmButton: "btn btn-success"
            }
          }).then((result) => {
            if (result.isConfirmed) {
              setFormValues({ old_pass: "", password: "", password2: "" })
              dispatch(setIsAcess(false))
              localStorage.clear()
              navigate("/")
            }
          })
        } else if (responseCode === 406 || response?.status === 406) {
          const { error } = response?.data?.data || {}

          const swalConfig = {
            icon: "error",
            title: "Failed!",
            customClass: {
              confirmButton: "btn btn-danger"
            }
          }

          if (error?.detail) {
            swalConfig.text = error.detail
          } else if (error?.message) {
            swalConfig.text = error.message
          } else if (error?.password) {
            swalConfig.html = error.password.map((msg) => `<p>${msg}</p>`).join("")
          } else {
            swalConfig.text = response?.data?.data?.message || "Password update failed."
          }

          MySwal.fire(swalConfig)
        } else {
          const errorMessage =
            response?.data?.data?.error?.detail ||
            response?.data?.data?.error?.message ||
            response?.data?.data?.message ||
            "Something went wrong."

          toast.error(errorMessage, {
            hideProgressBar: true
          })
        }
      })
      .catch((e) => {
        // console.log is disabled app-wide in App.jsx, so a swallowed failure
        // here left the user staring at an unchanged dialog with no clue why.
        console.error("Failed to update password", e)
      })

    // Handle error
  }

  //  to show sweet alert to confirm update password
  const handleConfirmText = () => {
    return MySwal.fire({
      text: `Are you sure want want to update it`,
      title: "Are you sure !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-outline-danger ml-1"
      },
      buttonsStyling: false
    }).then(function (result) {
      if (result.value) {
        updatePassword()
      }
    })
  }

  // on change function
  const onChangePassword = (event) => {
    const name = event.target.name
    const value = event.target.value
    setFormValues((values) => ({ ...values, [name]: value }))
  }

  return (
    <Card style={{ border: "none", boxShadow: "none", marginBottom: "16px" }}>
      <CardHeader className='card_header'>
        <CardTitle tag='h4'>New Password</CardTitle>
      </CardHeader>
      <CardBody>
        <Form
          // on submit form
          onSubmit={(e) => {
            e.preventDefault()
            //  To validate password
            if (formValues.password === formValues.password2) {
              handleConfirmText()
            } else {
              toast.error(" Re-check Password .", {
                hideProgressBar: true
              })
            }
          }}
        >
          <FormGroup row>
            <Label sm='4' for='old_pass'>
              Old Password
            </Label>
            <Col sm='8'>
              <InputGroup className='input-group-merge'>
                <InputPasswordToggle
                  id='old_pass'
                  name='old_pass'
                  className='input-group-merge'
                  value={formValues.old_pass}
                  onChange={onChangePassword}
                  required
                />
              </InputGroup>
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm='4' for='password'>
              New Password
            </Label>
            <Col sm='8'>
              <InputGroup className='input-group-merge'>
                <InputPasswordToggle
                  id='password'
                  name='password'
                  className='input-group-merge'
                  value={formValues.password}
                  onChange={onChangePassword}
                  required
                />
              </InputGroup>
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm='4' for='password2'>
              Confirm New Password
            </Label>
            <Col sm='8'>
              <InputGroup className='input-group-merge'>
                <InputPasswordToggle
                  id='password2'
                  name='password2'
                  className='input-group-merge'
                  value={formValues.password2}
                  onChange={onChangePassword}
                  required
                />
              </InputGroup>
            </Col>
          </FormGroup>

          <FormGroup className='mb-0 ' row>
            <Col className='d-flex gap-3' md={{ size: 9, offset: 3 }}>
              <Button className='mr-1' color='primary' type='submit'>
                Submit
              </Button>
              {/* On reset the form */}
              <Button
                outline
                color='secondary'
                type='reset'
                onClick={(e) => {
                  setFormValues("")
                }}
              >
                Reset
              </Button>
            </Col>
          </FormGroup>
        </Form>
      </CardBody>
    </Card>
  )
}
export default UpdatePassword
